export const removeStyledProps = (value: string | string[]) => {
  const arrayValue = typeof value === 'string' ? [value] : value;
  return {
    shouldForwardProp: (prop: string) => !arrayValue.includes(prop),
  };
};

export const removeStyledSmallScreenProp = removeStyledProps('smallScreen');
